// extracted by mini-css-extract-plugin
module.exports = {"IndividualScore":"IndividualScore_IndividualScore__22yQc"};